/*
 * Janela de exibição agendada — genérico, para qualquer elemento com
 * [data-schedule]. O Liquid já decide o que renderizar, mas o cache de
 * página da Shopify pode servir um HTML defasado e a aba pode ficar aberta
 * durante a virada; aqui o estado é reavaliado no relógio do visitante e um
 * timer é armado para a próxima fronteira.
 *
 * data-schedule-start / data-schedule-end vêm em epoch (segundos), já
 * normalizados pelo snippet schedule-timestamp no horário de Brasília —
 * assim os dois lados enxergam exatamente o mesmo instante. Vazio ou 0 =
 * sem limite naquele lado.
 *
 * Carregado globalmente em theme.liquid: são cinco sections agendáveis e o
 * custo de sair cedo quando nenhuma está na página é um querySelectorAll.
 */
const MAX_TIMEOUT = 2147483647;

function parseTimestamp(value) {
  const seconds = Number(value);
  if (!seconds) return null;
  return seconds * 1000;
}

function initSchedule(el) {
  const start = parseTimestamp(el.dataset.scheduleStart);
  const end = parseTimestamp(el.dataset.scheduleEnd);
  if (start === null && end === null) return;

  update();

  function update() {
    const now = Date.now();
    el.hidden = !((start === null || now >= start) && (end === null || now < end));

    let next = null;
    if (start !== null && now < start) {
      next = start;
    } else if (end !== null && now < end) {
      next = end;
    }
    if (next === null) return;

    // +1s de folga para não reavaliar no milissegundo exato da fronteira.
    setTimeout(update, Math.min(next - now + 1000, MAX_TIMEOUT));
  }
}

function init() {
  document.querySelectorAll('[data-schedule]').forEach(initSchedule);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
